<template>
  <div class="campaign-list">
    <v-list
      v-for="(campaign, index) in historicCampaigns"
      :key="index"
      dense
    >
      <v-card class="" outlined>
        <v-list-group
          color=""
          v-model="campaign.expand"
          append-icon=""
          class="py-0 my-0"
          :ripple="false"
        >
          <template v-slot:prependIcon>
            <div>
              <v-icon>
                {{ campaign.expand ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </div>
          </template>
          <template v-slot:activator>
            <v-list-item-title>
              <div class="d-flex justify-space-between align-center">
                <div
                  class="mt-1"
                  :style="
                    $vuetify.breakpoint.mdAndUp
                      ? `min-width: ${getMinWidth};`
                      : ''
                  "
                >
                  <span>
                    {{
                      campaign.title.length > 24 &&
                      $vuetify.breakpoint.smAndDown
                        ? campaign.title.toUpperCase().substr(0, 24)
                        : campaign.title.toUpperCase()
                    }}
                  </span>
                  <div
                    v-if="
                      campaign.title.length > 24 &&
                        $vuetify.breakpoint.smAndDown
                    "
                  >
                    <v-spacer />
                    {{ campaign.title.toUpperCase().substr(24) }}
                    <!-- {{ `${campaign.title}`.substr(24) }} -->
                  </div>
                  <!-- <span
                    v-if="
                      !$vuetify.breakpoint.smAndDown &&
                        !history &&
                          campaign.type_promo !== 'token'"
                  >
                    - {{ campaign.code_promo }}
                  </span> -->

                  <!-- <v-spacer
                    class="my-4"
                    v-if="$vuetify.breakpoint.smAndDown && history"
                  /> -->

                  <!-- <v-chip
                    small
                    class="ml-1 mb-2"
                    v-if="history"
                    :color="getColorByStatus(campaign.status).color"
                  >
                    <strong>
                      {{ getColorByStatus(campaign.status).text }}
                    </strong>
                  </v-chip> -->
                </div>
                <div v-if="$vuetify.breakpoint.mdAndUp" class="my-4">
                  <div class="d-flex flex-column mb-4">
                    <div class="mb-2">
                      {{ $t("winAmount") }}
                    </div>
                    <div>
                      <strong>
                        {{ `${$t("labelCurrency")} ${campaign.win_amount}` }}
                      </strong>
                    </div>
                  </div>

                  <div class="d-flex flex-column">
                    <div class="mb-2">
                      Qtd. de Rodadas
                    </div>
                    <div>
                      <strong>
                        {{ campaign.quantity }}
                      </strong>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column align-center my-4">
                  <div
                    v-if="
                      campaign.expiration_date && !$vuetify.breakpoint.smAndDown
                    "
                    class="d-flex flex-column align-end caption mb-4"
                  >
                    <div class="mb-2">
                      <v-icon small left>mdi-calendar</v-icon>
                      <span class="">{{ $t("dateExpiration") }}</span>
                    </div>
                    <div>
                      {{ handleExpirationDate(campaign.expiration_date) }}
                    </div>
                  </div>
                </div>
              </div>
            </v-list-item-title>
          </template>
          <template v-slot:default>
            <!-- Mobile -->
            <v-divider v-if="$vuetify.breakpoint.smAndDown" />
            <v-list-item v-if="$vuetify.breakpoint.smAndDown">
              <v-list-item-content class="d-flex caption">
                <div
                  class="d-flex align-top my-3"
                  :class="
                    $vuetify.breakpoint.xs
                      ? ' justify-space-between'
                      : ' justify-space-around'
                  "
                >
                  <div class="d-flex flex-column">
                    <div class="mb-2">
                      {{ $t("winAmount") }}
                    </div>
                    <strong class="">
                      {{ `${$t("labelCurrency")} ${campaign.win_amount}` }}
                    </strong>
                  </div>
                  <div
                    v-if="campaign.expiration_date"
                    class="d-flex flex-column align-end justify-center"
                  >
                    <div class="mb-2">
                      <v-icon small left>mdi-calendar</v-icon>
                      <span>{{ $t("dateExpiration") }}</span>
                    </div>
                    <div>
                      {{ handleExpirationDate(campaign.expiration_date) }}
                    </div>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <template v-for="(game, index) in campaign.games">
              <v-list-item :key="game.game_id">
                <v-list-item-content>
                  <v-list-item-title v-text="game.game_name" />
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    height="30"
                    class="primary text-capitalize py-0 px-10"
                    @click="playGame(game.game_id)"
                  >
                    Jogar
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-divider
                v-if="index < campaign.games.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </template>
        </v-list-group>
      </v-card>
    </v-list>
  </div>
</template>
<script>
export default {
  props: ["historicCampaigns"],

  data: () => ({
    campaign: {},
    campaignDetailDialog: false,
    campaignExtractDialog: false,
    currentcampaignDetail: {},
    currentcampaignExtract: {},
  }),

  computed: {
    bonusBalance() {
      return this.$store.state.cashBonus.status == "1" &&
        this.$store.state.cashBonus.value > 0
        ? this.$store.state.cashBonus.value
        : 0;
    },

    getMinWidth() {
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint == "md") {
        return "40%";
      } else if (breakpoint == "lg") {
        return "30%";
      } else if (breakpoint == "xl") {
        return "20%";
      }

      return "";
    },

    allCasinoGames() {
      return this.$store.state.casinoGames;
    },
  },

  mounted() {
    console.log("allCasinoGames:", this.allCasinoGames);
  },

  watch: {
    historicCampaigns(val) {
      console.log("historicCampaigns:", val);
    },
  },

  methods: {
    playGame(gameId) {
      console.log(gameId);
      console.log(
        this.allCasinoGames.map((casinoType) => casinoType.game_id == gameId)
      );
      // console.log(this.allCasinoGames.map((casinoType) => {
      //   return casinoType.game_id == gameId
      // }))
      // if (!this.$store.state.logged.status) {
      //   const casinoType = this.$route.params.casinoType;

      //   game.redirectUrl = `/casino/lobby/${casinoType}/category/${game.categoryName}/game/${game.game_id}`;
      //   game.redirectUrl += `?demo=${!!demo}`;

      //   this.$root.$emit("openUnloggedDialog", game);
      //   return;
      // }

      // const params = {
      //   gameId: game.game_id,
      //   category: game.categoryName,
      // };

      // this.$router.push({
      //   name: "casinoGameCategory",
      //   params,
      //   query: { demo },
      // });
    },

    handleExpirationDate(expirationDate) {
      return new Date(expirationDate.replace(" ", "T")).toLocaleDateString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    getColorByStatus(status) {
      const colors = {
        0: { text: this.$t("inactive"), color: "blue-grey" },
        1: { text: this.$t("active"), color: "green" },
        2: { text: this.$t("finishedcampaign"), color: "grey darken-4" },
        3: { text: this.$t("canceled"), color: "purple darken-2" },
        4: { text: this.$t("expired"), color: "warning" },
      };

      return colors[status];
    },
  },
};
</script>
<style scoped>
.campaign-list .v-list-item__icon {
  display: flex;
  align-self: center;
}
</style>
